import { createSlice } from '@reduxjs/toolkit';

const chatHistorySlice = createSlice({
	name: 'chatHistory',
	initialState: {
		history: [],
		firstLoad: true,
	},
	reducers: {
		setChatHistory: (state, action) => {
			state.history = action.payload;
		},
		clearChatHistory: (state) => {
			state.history = [];
		},
		addChatHistory: (state, action) => {
			state.history.unshift(action.payload);
		},
		setFirstLoad: (state, action) => {
			state.firstLoad = action.payload;
		},
		resetChatHistory: (state) => {
			state.history = [];
			state.firstLoad = true;
		},
		renameChatSession: (state, action) => {
			const { sessionId, newName } = action.payload;
			const session = state.history.find(s => s.session_id === sessionId);
			if (session) session.session_name = newName;
		},
		deleteChatSession: (state, action) => {
			const sessionId = action.payload;
			state.history = state.history.filter(s => s.session_id !== sessionId);
		},
	}
});

export const {
	setChatHistory,
	clearChatHistory,
	addChatHistory,
	setFirstLoad,
	resetChatHistory,
	renameChatSession,
	deleteChatSession,
} = chatHistorySlice.actions;

export default chatHistorySlice.reducer;
